import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import LabelField from "./labelField";
import { useDispatch } from "react-redux";
import SquareCheckBox from "./SquareCheckBox";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

function SubjectNamePopUp(props) {
  const dispatch = useDispatch();
  const [examList, setExamList] = useState(props?.selectedList);
  const [exam, setExam] = useState(null);
  const [allSelectedExamList, setAllSelectedExamList] = useState([]);
  const hasSyncedRef = useRef(false);

  useEffect(() => {
    if (props.open) {
      hasSyncedRef.current = false;
    }
  }, [props.open]);

  const onSelectExam = (event, index) => {
    const isChecked = event.target.checked;
    let newArray = [];
    if (props?.activeTemplate?.id === 1) {
      newArray = examList.map((examItem, i) => {
        if (i === index) {
          return {
            ...examItem,
            isSelected: isChecked,
          };
        }
        return examItem;
      });
    } else if (
      props?.activeTemplate?.id === 2 ||
      props?.activeTemplate?.id === 7 ||
      props?.activeTemplate?.id === 3 ||
      props?.activeTemplate?.id === 4 ||
      props?.activeTemplate?.id === 8 ||
      props?.activeTemplate?.id === 5 ||
      props?.activeTemplate?.id === 6 ||
      props?.activeTemplate?.id === 9 ||
      props?.activeTemplate?.id === 10 ||
      props?.activeTemplate?.id === 13
    ) {
      newArray = examList.map((examItem, i) => {
        return {
          ...examItem,
          isSelected: i === index ? isChecked : false,
        };
      });
      let tempSubject = examList[index];
      props.onSelectTopics(tempSubject);
    }
    setExamList(newArray);
    props.onSelectExams(newArray);
  };

  return (
    <Modal
      className="model"
      open={props.open}
      onClose={props.handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={props.open}>
        <div className="Exammodeldiv p-3">
          <form>
            <div className="col mb-4 d-flex justify-content-between">
              <h5 className="fw-bold me-4 colorPurple">Subject Name</h5>
              <ClearOutlinedIcon
                className="colorPurple cursor"
                onClick={props.handleClose}
              />
            </div>

            <div className="position-relative py-3 mb-3 d-flex align-items-start justify-content-start">
              <div className="d-flex mb-2 align-items-start">
                <LabelField labelName={"Subject Name"} isRequired />
                {examList?.length > 0 && (
                  <div className="d-flex align-items-start">
                    <div className="border border-1 rounded-2 w-100">
                      {examList.map((c, index) => (
                        <div
                          className="d-flex font-12 align-items-center border-bottom py-1 px-2 mb-1"
                          key={c._id}
                        >
                          <SquareCheckBox
                            id={c._id}
                            type="checkbox"
                            name="Subject Name"
                            value={c.name}
                            checked={c.isSelected}
                            onChange={(e) => onSelectExam(e, index)}
                          />

                          <div className="d-flex justify-content-between align-items-center cursor w-100">
                            <div>{c.name}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </Fade>
    </Modal>
  );
}

export default SubjectNamePopUp;
